/** Starter stub — EMS admission fee portal removed from platform template. */
export default function AdmissionFeePortalDialog() {
  return null;
}
